import { useSnapshot } from "valtio"
import {
    quoteDataRec, chargesStore1
} from './state/CommonState'
import Utils from "./util/Utils"
import { configStore } from "./state/CommonState"
export default function ChargesView1() {

    let imChargesStore = useSnapshot(chargesStore1)
    console.log('Inside ChargesView render=', imChargesStore.list.length)
    console.log('Full list = ', JSON.stringify(chargesStore1.list))
    const Tn = ({ i, name }) => {
        const e = chargesStore1.list[i]
        if (e.disabled && e.disabled.indexOf(name) >= 0)
            return (
                <div style={{ color: '#dddddd', backgroundColor: '#dddddd', border: 'none', width: '5rem' }} >.</div>
            )
        else if (name === 'total') {
            return (
                <span style={{textAlign: 'right'}}>{Utils.N(e[name], e.currency)}</span>
            )
        } else {
            //console.log(name, e.currency, e[name])
            let num = e[name]
            num = isNaN(num)?0.0:Number(num)
            return num>0?<span>{Utils.N(num, e.currency)}</span>:<></>
        }
    }
    const displayRec = (e) => {
        const perCBM = parseFloat(e.perCBM)
        const perTon = parseFloat(e.perTon)
        const perShipment = parseFloat(e.perShipment)
        const total = parseFloat(e.total)
        console.log(perCBM, perTon, perShipment, total)
        if (perCBM > 0 || perTon > 0 || perShipment > 0 || total > 0) return true
        return false
    }
    let grandTotal = 0.0
    chargesStore1.list.map(e => {
        let erate = configStore.getExchangeRateinr(e)
        if (!erate || erate === 0) erate = 1.0
        
        grandTotal += parseFloat(e.total ) * erate
        console.log('E.TOTAL***=', e.total, grandTotal, e.currency, erate)
    })
    let counter = 1
    return (
        <>
            <hr />
            <div className="table-container">
                <table className="table is-bordered is-striped is-narrow is-hoverable ">
                    <thead>
                        <tr>
                            <th colSpan='12'>
                                <h3 className="is-size-5 has-text-centered">Charges</h3>
                            </th>
                        </tr>
                        <tr>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th colSpan='4' className="has-text-centered">Per Unit</th>
                            <th></th>
                            <th></th>
                        </tr>
                        <tr>
                            <th>ID</th>
                            <th style={{ width: '20rem' }}>Charge Description</th>
                            <th>Currency</th>
                            <th style={{textAlign:'center'}}>Per CBM</th>
                            <th style={{textAlign:'center'}}>Per Ton</th>
                            <th style={{textAlign:'center'}}>Minimum</th>
                            <th style={{textAlign:'center'}}>Maximum</th>
                            <th style={{textAlign:'center'}}>Per shipment</th>
                            <th style={{textAlign: 'right'}}>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            chargesStore1.list.map((e, i) => {
                                {
                                    return (displayRec(e)) ?
                                        <tr key={e.id}>
                                            <td >{counter++}</td>
                                            <td>{e.chargeDescription}</td>
                                            <td>{e.currency}</td>
                                            <td style={{textAlign:'center'}}><Tn i={i} name='perCBM' /></td>
                                            <td style={{textAlign:'enter'}}><Tn i={i} name='perTon' /></td>
                                            <td style={{textAlign:'center'}}><Tn i={i} name='minimum' /></td>
                                            <td style={{textAlign:'center'}}><Tn i={i} name='maximum' /></td>
                                            <td style={{textAlign:'center'}}><Tn i={i} name='perShipment' /></td>
                                            <td style={{textAlign: 'right'}}><Tn i={i} name='total' /></td>
                                        </tr> : <></>
                                }
                            }
                            )
                        }
                        <tr>
                            <td colSpan={8}></td>
                            <td style={{textAlign: 'right'}}><strong>{Utils.N(
                                chargesStore1.list.reduce((pVal,e) => {
                                    let erate = configStore.getExchangeRateinr(e)
                                    if (!erate || erate === 0) erate = 1.0
                                    pVal += parseFloat(e.total ) * erate;
                                    return pVal;
                                } , 0)
                            )}</strong></td>
                        </tr>
                        <tr>
                            <td colSpan={9} style={{textAlign: 'right'}}>Taxes & Duties additional, as applicable</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    )
}
